import React from "react";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import AddIcon from "@mui/icons-material/Add";
import ButtonOne from "../../common/normal-button";
import { ColorsConstants } from "../../cssUtils/constants";
import { Lock, Visibility } from "@mui/icons-material";
import AppTable from "../../common/app-table";
import TableSearchInput from "../TableSearchInput";

const dummyRoles = [
  { id: 1, name: "Admin", createdOn: "09-Jan-2026 06:57 PM" },
  { id: 2, name: "Campaign Checker", createdOn: "09-Jan-2026 06:57 PM" },
  { id: 3, name: "Campaign Maker", createdOn: "09-Jan-2026 06:57 PM" },
  { id: 4, name: "Chat Agent", createdOn: "09-Jan-2026 06:57 PM" },
  { id: 5, name: "Support", createdOn: "09-Jan-2026 06:57 PM" },
];

const tableHeadCellSx = {
  backgroundColor: ColorsConstants.primaryBackgroundColor,
  color: "#fff",
  fontSize: 13,
  fontWeight: 500,
  py: 1.5,
  px: 2.5,
  whiteSpace: "nowrap",
  borderBottom: "none",
};

const tableBodyCellSx = {
  fontSize: 13,
  color: "#04142F",
  py: 1.25,
  px: 2.5,
  borderBottom: "1px solid #F0F4F8",
};

const RolesAndPermissions = (props) => {
  const [search, setSearch] = React.useState("");

  const filteredRoles = dummyRoles.filter((role) =>
    role.name.toLowerCase().includes(search.toLowerCase()),
  );

  const tableColumns = [
    {
      id: "name",
      label: "Roles",
      minWidth: "40%",
    },
    {
      id: "createdOn",
      label: "Created On",
      minWidth: "40%",
    },
    {
      id: "__actions__",
      label: "Action",
      minWidth: "20%",
      render: (role) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <IconButton
            size="small"
            sx={{
              color: "#6C7C93",
              borderRadius: "6px",
              "&:hover": { bgcolor: "#F0F2F8", color: ColorsConstants.primaryBackgroundColor },
            }}
          >
            <Visibility fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            sx={{
              color: "#6C7C93",
              borderRadius: "6px",
              "&:hover": { bgcolor: "#F0F2F8", color: ColorsConstants.primaryBackgroundColor },
            }}
          >
            <Lock fontSize="small" />
          </IconButton>
        </Box>
      ),
    },
  ];
 

  return (
    <Box sx={{ backgroundColor: "#FAFAFA", minHeight: "100vh" }}>
      {/* Top Header Section */}
      <Box
        sx={{
          px: 3,
          py: 2,
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        {/* Search with counter */}
        <Box sx={{ flex: 1, position: "relative" }}>
          <TableSearchInput
            searchQuery={search}
            onSearchChange={(e) => setSearch(e.target.value)}
            tooltip="Search"
            placeholder="Search"
          />
        </Box>

        {/* Add Role Button */}
        <ButtonOne
          variant="contained"
          sx={{
            whiteSpace: "nowrap",
            height: 40,
            px: 2.5,
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
          startIcon={<AddIcon sx={{ fontSize: 18 }} />}
        >
          Add Role
        </ButtonOne>
      </Box>

      {/* Table Section */}
      <Box sx={{ px: 3 }}>
        {/* <Paper
         
          sx={{
            width: "100%",
            overflow: "hidden",
            border: "1px solid #DCDFE5",
            borderRadius: "8px",
          }}
        > */}
          <AppTable
            columns={tableColumns}
            rows={filteredRoles}
            rowKey="id"
            emptyMessage="No roles found"
            maxHeight={600}
          />
        {/* </Paper> */}
      </Box>
    </Box>
  );
};

export default RolesAndPermissions;
